import { Box, Paper, SxProps, Typography } from '@mui/material';
import { SidebarLogo } from 'components/BaseLayout/BaseLayout';

export interface MobileHeaderProps {
  children?: React.ReactNode;
  title?: string;
}

const sx: SxProps = {
  display: {
    xs: 'block',
    md: 'none'
  },
  ml: -2,
  p: 2,
  position: 'fixed',
  top: 0,
  width: '100%',
  zIndex: 1
};

const MobileHeader = ({ title, children }: MobileHeaderProps) => {
  return (
    <Paper sx={sx}>
      <SidebarLogo />
      {title && (
        <Box sx={{ mt: 1 }}>
          <Typography>{title}</Typography>
        </Box>
      )}
      {children && <Box sx={{ mt: 1 }}>{children}</Box>}
    </Paper>
  );
};

export default MobileHeader;
